module.exports = __webpack_public_path__ + "img/american-express.6fb3ba9a.png";